<div class="container-fluid">
    <div class="row mt-3">
        <div class="col-2">
            <div class="card">
                <div class="card-body">
                    <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                        <a class="nav-link active" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home"
                            role="tab" aria-controls="v-pills-home" aria-selected="true">Printers</a>
                        <a class="nav-link" id="v-pills-profile-tab" data-toggle="pill" href="#v-pills-profile"
                            role="tab" aria-controls="v-pills-profile" aria-selected="false">Printer Types</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-10">
            <div class="card">
                <div class="card-body">
                    <div class="tab-content" id="v-pills-tabContent">
                        <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel"
                            aria-labelledby="v-pills-home-tab">
                            <a href="/hardware/printers/insert" class="btn btn-primary btn-sm float-right">Add
                                Printer</a>
                            <div class="clearfix"></div>
                            <hr />
                            <div class="clearfix"></div>
                            <app-data-table [columns]="columns" [loadPage]="loadPage"
                                [(filters)]="filters" [filtersComponent]="dataFilters">
                                <app-data-filters #dataFilters>
                                    <app-data-filter-group>
                                        <app-data-filter-input label="Printer Identifier" [(model)]="filters.identifier"
                                            placeholder="Printer Identifier">
                                        </app-data-filter-input>
                                        <app-data-filter-input label="Printer Name" [(model)]="filters.name"
                                            placeholder="Printer Name">
                                        </app-data-filter-input>
                                        <app-data-filter-select label="Printer Status" placeholder="Printer Status"
                                            [(model)]="filters.status" [options]="printerStatusArray">
                                        </app-data-filter-select>
                                        <app-data-filter-datepicker label="Start Date" [(model)]="filters.startdate">
                                        </app-data-filter-datepicker>
                                        <app-data-filter-datepicker label="End Date" [(model)]="filters.enddate">
                                        </app-data-filter-datepicker>
                                    </app-data-filter-group>
                                </app-data-filters>
                            </app-data-table>
                        </div>
                        <div class="tab-pane fade" id="v-pills-profile" role="tabpanel"
                            aria-labelledby="v-pills-profile-tab">
                            <div style=" padding: 1px 2px 3px 4px;">
                                <a href="/hardware/printer-types/insert" class="btn btn-primary btn-sm float-right">Add
                                    New Printer Type</a>
                            </div>
                            <div class="table-responsive data-table-column">
                                <table class="table table-sm text-left">
                                    <thead>
                                        <tr>
                                            <th>Printer Type Name</th>
                                            <th>Lan</th>
                                            <th>Bluetooth</th>
                                            <th>Wifi</th>
                                            <th>Usb</th>
                                            <th>Status</th>
                                            <th>Is Fiscal Printer</th>
                                            <th class="text-right">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let printerType of printerTypeVals">
                                            <td>{{printerType.name}}</td>
                                            <td>
                                                <ng-container *ngIf="printerType.lan === true; else noLan">
                                                    <i style="color: green;" class="fas fa-check"></i>
                                                </ng-container>
                                                <ng-template #noLan>
                                                    <i style="color: red;" class="fas fa-times"></i>
                                                </ng-template>
                                            </td>
                                            <th>
                                                <ng-container *ngIf="printerType.bluetooth === true; else noBluetooth">
                                                    <i style="color: green;" class="fas fa-check"></i>
                                                </ng-container>
                                                <ng-template #noBluetooth>
                                                    <i style="color: red;" class="fas fa-times"></i>
                                                </ng-template>
                                            </th>
                                            <td>
                                                <ng-container *ngIf="printerType.wifi === true; else noWifi">
                                                    <i style="color: green;" class="fas fa-check"></i>
                                                </ng-container>
                                                <ng-template #noWifi>
                                                    <i style="color: red;" class="fas fa-times"></i>
                                                </ng-template>
                                            </td>
                                            <td>
                                                <ng-container *ngIf="printerType.usb === true; else noUsb">
                                                    <i style="color: green;" class="fas fa-check"></i>
                                                </ng-container>
                                                <ng-template #noUsb>
                                                    <i style="color: red;" class="fas fa-times"></i>
                                                </ng-template>
                                            </td>
                                            <td>{{printerType.status | printerTypeStatus}}</td>
                                            <td>
                                              <ng-container *ngIf="printerType.isFiscalPrinter; else noFiscalPrinter">
                                                <i style="color: green;" class="fas fa-check"></i>
                                              </ng-container>
                                              <ng-template #noFiscalPrinter>
                                                <i style="color: red;" class="fas fa-times"></i>
                                              </ng-template>
                                            </td>
                                            <td class="text-right">
                                                <a href="hardware/printer-types/update/{{printerType.id}}"
                                                    class="btn btn-secondary btn-sm"><i class="fa fa-pencil-alt"></i>
                                                    Edit</a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #id let-id="id">
    <input type="checkbox" [value]="id" />
</ng-template>

<ng-template #name let-name="name">
    {{name}}
</ng-template>

<ng-template #identifier let-identifier="identifier">
    {{identifier}}
</ng-template>

<ng-template #printerAssignedCount let-printerAssignedCount="printerAssignedCount">
  {{printerAssignedCount}}
</ng-template>

<ng-template #assignedEvent let-assignedEvent="assignedEvent">
  <div style="width:200px; height:50px; overflow-y: scroll; background-color: #fafafa; padding:3px 6px;" [innerHtml]="showAssignedEvent(assignedEvent)" *ngIf="assignedEvent"></div>
</ng-template>

<ng-template #statusColumn let-status="status">
    {{status | printerStatus}}
</ng-template>

<ng-template #printerType let-printerType="printerType">
    {{printerType.name}}
</ng-template>

<ng-template #lan let-printerType="printerType">
    <ng-container *ngIf="printerType.lan === true; else noLan">
        <i style="color: green;" class="fas fa-check"></i>
    </ng-container>
    <ng-template #noLan>
        <i style="color: red;" class="fas fa-times"></i>
    </ng-template>
</ng-template>

<ng-template #bluetooth let-printerType="printerType">
    <ng-container *ngIf="printerType.bluetooth === true; else noBluetooth">
        <i style="color: green;" class="fas fa-check"></i>
    </ng-container>
    <ng-template #noBluetooth>
        <i style="color: red;" class="fas fa-times"></i>
    </ng-template>
</ng-template>

<ng-template #wifi let-printerType="printerType">
    <ng-container *ngIf="printerType.wifi === true; else noWifi">
        <i style="color: green;" class="fas fa-check"></i>
    </ng-container>
    <ng-template #noWifi>
        <i style="color: red;" class="fas fa-times"></i>
    </ng-template>
</ng-template>

<ng-template #usb let-printerType="printerType">
    <ng-container *ngIf="printerType.usb === true; else noUsb">
        <i style="color: green;" class="fas fa-check"></i>
    </ng-container>
    <ng-template #noUsb>
        <i style="color: red;" class="fas fa-times"></i>
    </ng-template>
</ng-template>
<ng-template #rentingCode let-rentingCode="rentingCode">{{rentingCode}}</ng-template>

<ng-template #printerManufacturers let-printerType="printerType">
    {{printerType.printerManufacturers.name}}
</ng-template>

<ng-template #companies let-companies="companies">
  {{formatCompanyName(companies)}}
</ng-template>

<ng-template #notes let-notes="notes">
  <ng-container *ngIf="notes; else noNotes">
      <div class="notes-container">
        <i style="color: #1DC7EA;" class="notes-icon fas fa-2x fa-info-circle"></i>
        <div class="notes-content">
          <div class="title">Notes</div>
          <div class="content" [innerHTML]="notes | replaceLineBreaks"></div>
        </div>
      </div>
  </ng-container>
  <ng-template #noNotes>
  </ng-template>
</ng-template>

<ng-template #actionsColumn let-id="id">
    <div class="btn-group navbar p-0" style="flex-wrap: nowrap">
        <a href="hardware/printers/update/{{id}}" class="btn btn-secondary btn-sm" style="height: 50px"><i class="fa fa-pencil-alt"></i>
            Edit</a>
        <button type="button" class="btn btn-sm btn-secondary dropdown-toggle dropdown-toggle-split"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="width: 30px; height: 50px">
            <span class="sr-only">Toggle Dropdown</span>
        </button>
        <div class="dropdown-menu dropdown-menu-right">
            <a href="hardware/printers/view/{{id}}" class="dropdown-item btn btn-sm"><i class="fa fa-search-plus"></i>
                View</a>
            <button type="button" class="dropdown-item btn-sm" (click)="softDeletePrinter(id, '0')"><i
                    class="fa fa-trash-alt"></i>Delete</button>
        </div>
    </div>
</ng-template>
